import { trackEvent } from "../../core/trackEvent";

// Utility function to wait for a given number of milliseconds
const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

const CREDENTIALS = "ff5d8c9e53msh91b2b0e0abb9d64p1c4c04jsn21e74c8acc9a";
const RETRY_LIMIT = 3;
const BASE_URL = "https://booking-com.p.rapidapi.com/";

// biome-ignore lint/suspicious/noExplicitAny: Because
export async function doRequest(endpoint: string, body: Record<string, any>) {
  const headers = new Headers();

  headers.append("Content-Type", "application/json");
  headers.append("x-rapidapi-host", "booking-com.p.rapidapi.com");
  headers.append("x-rapidapi-key", CREDENTIALS);

  const url = `${BASE_URL}${endpoint}`;

  for (let attempt = 0; attempt <= RETRY_LIMIT; attempt++) {
    let response: Response;
    const start = performance.now(); // Start the timer

    if (__DEV__) {
      // Use proxy for dev
      const requestOptions: RequestInit = {
        method: "POST",
        headers,
        body: JSON.stringify({
          url,
          requestBody: body,
        }),
      };

      response = await fetch("http://localhost:3000/proxy", requestOptions);
    } else {
      const requestOptions: RequestInit = {
        method: "GET",
        headers,
      };

      const queryString = new URLSearchParams(body).toString();
      const fullUrl = `${url}?${queryString}`;

      response = await fetch(fullUrl, requestOptions);
    }

    const end = performance.now(); // End the timer
    const ms = end - start; // Calculate duration
    trackEvent("affiliate_hotels_api_duration", { ms });

    if (response.ok) {
      const resultJson = await response.json();
      trackEvent("affiliate_hotels_api_ok");
      return resultJson;
    }

    if (response.status === 429) {
      trackEvent("affiliate_hotels_api_rate_limited");
      console.info("Rate limited, retrying after 3 seconds...");
      await sleep(3000);
    } else {
      trackEvent("affiliate_hotels_api_error");
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  }

  trackEvent("affiliate_hotels_api_exceeded_retry_limit");
  throw new Error("Exceeded retry limit");
}
